import React from 'react';
import './index.css'
import gongan from './../../images/gongan.png'
import szicbok from './../../images/szicbok.png'
export default class Copyright extends React.Component {
    render() {
        return (
            <div className="footer">
                <p>Copyright © 2012 - 2032 苏州乐聘体育文化策划有限公司. All Rights Reserved.</p>
                <p>苏州市吴中区东吴北路111号东吴乐享汇二楼</p>
                <div>
                    {/* <img src={gongan} alt=""></img> */}
                    <a target="_blank" href="http://www.beian.miit.gov.cn"><span>苏ICP备19071005号-1</span></a>
                    {/* <img src={szicbok} alt=""></img>
                    <span>苏公网安备32050802010878号</span> */}
                </div>
            </div>
        );
    }
}